import { render } from "./App.vue?vue&type=template&id=3f2ac083"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3f2ac083&lang=css"
script.render = render

export default script